export const useBaseControllerViewBag = () => {
    return {
        ...(window as any).baseControllerViewBag
    }
}